import { BPCTableField } from '@shared/interfaces/bpc-table-interface';

// Config to display columns
export const accessPointDisplayFields = {
  code: {
    displayType: 'code',
    key: 'code',
  },
  status: {
    displayType: 'badge',
    valueToLabel: [
      { value: 'active', label: 'global.fields.status.active.label' },
      { value: 'inactive', label: 'global.fields.status.inactive.label' },
      { value: 'trrash', label: 'global.fields.status.trash.label' },
    ],
    valueToVariant: [
      { value: 'active', variant: 'success' },
      { value: 'inactive', variant: 'danger' },
    ],
  },
  resources: {
    displayType: 'array',
    fieldPath: 'code',
    fieldReadPath: 'code',
  },
  consumeProduct: {
    displayType: 'badge',
    valueToLabel: [
      { value: true, label: 'global.yes' },
      { value: false, label: 'global.no' },
    ],
    valueToVariant: [
      { value: true, variant: 'success' },
      { value: false, variant: 'light' },
    ],
  },
  contact: {
    displayType: 'contact-link',
    useDrawer: true,
    formConfigName: 'edit',
    drawerSize: 'lg',
    configFileName: 'contact',
  },
};

// Columns displayed by default
export const defaultTableFields: BPCTableField[] = [
  {
    key: 'code',
    headerLabel: `access_control.access_point.code.header`,
    order: 0,
  },
  {
    key: 'name',
    headerLabel: `access_control.access_point.name.header`,
    order: 1,
  },
  {
    key: 'resources',
    headerLabel: `access_control.access_point.resource.header`,
    order: 2,
  },
  {
    key: 'status',
    headerLabel: `access_control.access_point.status.header`,
    order: 3,
  },
  {
    key: 'consumeProduct',
    headerLabel: `access_control.access_point.consume_product.header`,
    order: 4,
  },
];

export const resourceTableFields: BPCTableField[] = [
  {
    key: 'code',
    headerLabel: `access_control.access_point.code.header`,
    order: 0,
  },
  {
    key: 'name',
    headerLabel: `access_control.access_point.name.header`,
    order: 1,
  },
  // TODO: delete?
  {
    key: 'resources',
    headerLabel: `access_control.access_point.resource.header`,
    order: 2,
  },
  {
    key: 'status',
    headerLabel: `access_control.access_point.status.header`,
    order: 3,
  },
  {
    key: 'consumeProduct',
    headerLabel: `access_control.access_point.consume_product.header`,
    order: 4,
  },
];

// Field config for forms
export const resourceAccessFieldConfig = {
  resource_id: {
    label: 'access_control.access_point.resource.label',
    showlabel: true,
  },

  access_type: {
    label: 'access_control.access_point.access_type.label',
    options: [
      {
        text: 'access_control.access_point.access_type.entry.label',
        value: 'entry',
      },
      {
        text: 'access_control.access_point.access_type.exit.label',
        value: 'exit',
      },
    ],
  },
};

export const accessPointFieldConfig = {
  id: {
    fieldPath: 'id',
    fieldReadPath: 'id',
    name: 'id',
  },
  center_id: {
    fieldPath: 'center_id',
    fieldReadPath: 'center_id',
    name: 'center_id',
  },
  code: {
    fieldPath: 'code',
    fieldReadPath: 'code',
    name: 'code',
    label: 'access_control.access_point.code.label',
    id: 'access_point__code',
    veeValidation: true,
    rules: ['nullable', 'string', 'without_spaces'],
    warningRules: [],
  },
  name: {
    fieldPath: 'name',
    fieldReadPath: 'name',
    name: 'name',
    label: 'access_control.access_point.name.label',
    id: 'access_point__name',
    veeValidation: true,
    rules: ['required'],
  },
  description: {
    fieldPath: 'description',
    fieldReadPath: 'description',
    name: 'description',
    label: 'access_control.access_point.description.label',
    id: 'access_point__description',
    veeValidation: true,
    rules: ['nullable', 'string'],
  },
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'access_control.access_point.status.label',
    inputType: 'select',
    options: [
      {
        text: 'global.fields.status.active.label',
        value: 'active',
      },
      {
        text: 'global.fields.status.inactive.label',
        value: 'inactive',
      },
    ],
    id: 'access_point__status',
    rules: [],
    defaultValue: 'active',
    valueToColor: [
      {
        value: 'active',
        color: 'border-0 text-white bg-success',
      },
      {
        value: 'inactive',
        color: 'border-0 text-white bg-danger',
      },
    ],
  },
  consumeProduct: {
    fieldPath: 'consumeProduct',
    errorFieldPath: 'consumeProduct',
    fieldReadPath: 'consumeProduct',
    name: 'consumeProduct',
    id: 'access_point__consume-product',
    veeValidation: true,
    rules: ['boolean'],
    label: 'access_control.access_point.consume_product.label',
    labelAttributes: {
      for: 'access_point__consume',
    },
    showHelp: true,
    helpMode: 'tooltip',
    help: 'help.access_control.access_point.consume_product',
  },
  resourceAccessConfigurations: {
    name: 'resourceAccessConfigurations',
    fieldPath: 'resourceAccessConfigurations',
    fieldReadPath: 'resourceAccessConfigurations',
  },
};
